import topWindowWithSameOrigin from './topWindowWithSameOrigin.js';
import version from '../../version.js';
import urlQueryToObject from './urlQueryToObject.js';

/** @namespace config */

export default function(adTag, element, sm_id, content_id, key, statusCode, playCode, language = 'en')
{
	const width = element.clientWidth;
	const height = element.clientHeight;
	const url = topWindowWithSameOrigin().location.href.split('#')[0];
	const hostname = (new URL(config.smartMatchLocation)).hostname;
	const domain = (hostname.match(/(?:[^. ]{4,})(?:\.[^. ]{1,3})+$/)||[])[0] || hostname;
	const random = Math.floor(Math.random()*20) + 1;
	const playerSize =
	[
		'small',
		'medium',
		'large',
		'hd'
	]
	[
		(width >= 400) + (width >= 601)// + (width >= 1280)
	];

	let param = urlQueryToObject(adTag,true);
	let cust_params = urlQueryToObject(decodeURIComponent(param['cust_params']));

	let adUnitSuffix = '';

	if(config.feed.enableAdUnitSuffix)
	{
		if(random > 10)
		{
			adUnitSuffix = '/control';
		}
		else
		{
			const inViewAndNotHidden = !config.ac_id.outsideViewPort && !config.ac_id.pageHidden;
			if(inViewAndNotHidden)
			{
				adUnitSuffix = '/HV';
			}
			else
			{
				adUnitSuffix = '/LV';
			}
		}
	}

	// noinspection SpellCheckingInspection
	param =
	{
		iu: param['iu'] + adUnitSuffix,
		env: 'vp',
		gdfp_req: 1,
		unviewed_position_start: 1,
		ad_rule: 1,
		output: 'xml_vmap1',
		//sz: `${width}x${height}`,
		// Business Rule: sz argument is hardcoded for targetting purposes.
		// height and width are custom parameters instead
		sz: '480x270',
		ciu_szs: '300x60',
		description_url: url,
		hl: language,
		vpa: 'auto',
		vpmute: 1,
		vconp: 2,
		cmsid: 2460952,
		vid: sm_id,
		cust_params:
		{
			pchain: cust_params['pchain'],
			content: content_id,
			placementType: config.feed.adPlacement,
			embed: key,
			domain: domain,
			player_size: playerSize,
			player_width: width,
			player_height: height,
			player_type: config.feed.playerType.toLowerCase(),
			version: version,
			player_status: statusCode,
			// ac_id is an object so coerce it to string before query generation
			play_code: ''+config.ac_id,
			rand: random
		}
	};

	return ['https://pubads.g.doubleclick.net/gampad/ads?',param];
};
